import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroWithMedia from '../../components/HeroWithMedia/HeroWithMedia';
import StreamField from '../../components/StreamField';
import styles from './AccessoryPage.module.scss';
import Breadcrumbs from '../../components/Breadcrumbs';

const AccessoryPage = ({ settings = {
        heroWithMedia: {},
        footer: {},
    }, hero = {}, content = [], breadcrumbs = {
        links: [],
    } }) => {
    return (
        <div className={styles['AccessoryPage']}>
            <Header {...settings.header} />
            <main>
                <div className={styles['AccessoryPage__Breadcrumbs']}>
                    <Breadcrumbs {...breadcrumbs} />
                </div>
                <div className={styles['AccessoryPage__HeroWrapper']}>
                    {hero && <HeroWithMedia {...hero} video={true} />}
                </div>
                {content && <StreamField items={content} />}
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

AccessoryPage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
    content: PropTypes.array,
    breadcrumbs: PropTypes.object,
};

export default basePageWrap(AccessoryPage);
